/**
 * Static mapping for resource slugs that differ between English and Spanish.
 * Keep this in sync with resources.slug_es and the SEO ownership registry.
 */
export const RESOURCE_SLUG_EN_TO_ES: Record<string, string> = {
  "shopify-faceted-navigation-crawl-budget": "shopify-filtros-presupuesto-rastreo",
  "woocommerce-to-shopify-migration": "migracion-woocommerce-shopify",
  "shopify-app-bloat-performance": "bloat-apps-shopify-rendimiento",
  "shopify-performance-optimization-guide": "guia-optimizacion-rendimiento-shopify",
  "shopify-replatforming-playbook": "playbook-replatforming-shopify",
  "shopify-conversion-rate-optimization-playbook": "playbook-cro-shopify",
  "shopify-performance-optimization": "optimizacion-velocidad-shopify",
  "shopify-speed-optimization-core-web-vitals": "optimizacion-velocidad-shopify-core-web-vitals",
  "how-to-choose-shopify-expert": "como-elegir-un-experto-shopify",
  "shopify-canonical-tags-shopify-defaults-and-failures": "shopify-canonical-tags-defaults-y-fallos",
  "shopify-checkout-extensibility-2026": "shopify-checkout-extensibility-2026-es",
  "shopify-collection-pages-not-ranking": "paginas-de-coleccion-shopify-no-rankean",
  "shopify-agentic-storefronts-may-2026": "shopify-nuevas-reglas-compradores-ia-mayo-2026",
  "shopify-cro-conversion-rate": "shopify-cro-conversion",
  "technical-seo": "seo-tecnico",
  performance: "rendimiento",
  migration: "migracion",
  "llantas-cavazos-shopify-migration-case-study": "caso-llantas-cavazos-migracion-shopify",
  "sitewide-lcp-regression-36-urls": "regresion-lcp-36-urls",
  "fashionable-canes-seo-case-study": "caso-fashionable-canes-seo",
  "fashionable-inc-partnership-case-study": "caso-fashionable-inc-colaboracion",
  "llantas-cavazos-migration-case-study": "caso-llantas-cavazos-migracion",
  "mp-health-squarespace-migration-case-study": "caso-mp-health-migracion-squarespace",
  "petwell-magento-migration-case-study": "caso-petwell-migracion-magento",
  "self-care-is-for-everyone-growth-case-study": "caso-self-care-is-for-everyone-crecimiento",
  "shopify-plus-pricing": "precios-shopify-plus",
};

export const RESOURCE_SLUG_ES_TO_EN: Record<string, string> = Object.fromEntries(
  Object.entries(RESOURCE_SLUG_EN_TO_ES).map(([en, es]) => [es, en]),
);

export function resourceSlugForLocale(enSlug: string, locale: "en" | "es"): string {
  if (locale === "en") return enSlug;
  return RESOURCE_SLUG_EN_TO_ES[enSlug] ?? enSlug;
}
